<template>
  <div
    class="lesson-list"
    :class="{
      'h5-lesson-list': isH5,
      'electron-lesson-list': isElectron,
    }"
  >
    <el-collapse v-model="activeNames" class="collapse-wrap">
      <el-collapse-item
        v-for="(unit, unitIndex) in unitList"
        :key="unit.id"
        :title="unit.unit_name"
        :name="unit.id"
      >
        <template slot="title">
          <div class="unit-name">
            <div class="name-text ellipsis">{{ unit.unit_name }}</div>
            <div class="unit-arrow">
              <span v-if="unit.lesson_list">{{
                unit.lesson_list.length || 0
              }}</span>
              <span
                class="arrow"
                :class="{ collapsed: activeNames.includes(unit.id) }"
              ></span>
            </div>
          </div>
        </template>
        <template v-if="unit.lesson_list && unit.lesson_list.length">
          <div class="lesson-list-wrap">
            <div
              class="lesson-item"
              :class="{
                'active-lesson-item': lesson.id === activeLesson.id,
                'lesson-locked': getLessonStatus(lesson) === 'locked',
              }"
              v-for="(lesson, lessonIndex) in unit.lesson_list"
              :key="lesson.id"
              @click="handleClickLesson(lesson)"
            >
              <!-- 状态图标 -->
              <div
                class="status-icon"
                :class="'status-' + getLessonStatus(lesson)"
              >
                <!-- 正在播放 -->
                <template v-if="getLessonStatus(lesson) === 'playing'">
                  <div class="ping-ring"></div>
                  <div class="play-circle">
                    <svg width="8" height="10" viewBox="0 0 8 10">
                      <polygon points="0,0 8,5 0,10" fill="#fff" />
                    </svg>
                  </div>
                </template>
                <!-- 未解锁 -->
                <template v-else-if="getLessonStatus(lesson) === 'locked'">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="var(--mg-text-muted)"
                    stroke-width="2"
                  >
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                    <path d="M7 11V7a5 5 0 0110 0v4" />
                  </svg>
                </template>
                <!-- 未开始：空心圆，无内容 -->
              </div>

              <div class="lesson-info">
                <div class="name">{{ lesson.lesson_name }}</div>
                <div class="other">
                  <!-- 类型标签 -->
                  <div class="tag-row">
                    <span
                      class="lesson-type-tag"
                      :class="getTypeTagClass(lesson)"
                    >
                      <template
                        v-if="getTypeTagClass(lesson) === 'tag-live-streaming'"
                      >
                        <span class="live-dot-wrap">
                          <span class="live-dot-ping"></span>
                          <span class="live-dot"></span>
                        </span>
                      </template>
                      {{ getTypeTagText(lesson) }}
                    </span>
                    <span
                      v-if="lesson.canTrial && !isRegistered"
                      class="lesson-type-tag can-trial"
                      >试听</span
                    >
                  </div>
                  <!-- 时长/老师信息 -->
                  <div class="meta-row">
                    <!-- 私教课-老师列表 -->
                    <template v-if="lesson.lesson_type === 4">
                      <div
                        v-if="isH5"
                        :id="'teacher' + lesson.id"
                        class="teacher"
                        :class="{
                          isOverflowing: isOverflowing('teacher' + lesson.id),
                        }"
                      >
                        <span>
                          {{ lesson.teachers }}
                        </span>
                        <img
                          @click.stop="showTeacherInfo(lesson.teachers)"
                          class="show-all"
                          src="../../../assets/images/arrow-right.png"
                          alt=""
                        />
                      </div>
                      <el-tooltip
                        v-else
                        popper-class="moguo-tooltip video-play-lesson-list"
                        class="item"
                        effect="dark"
                        :content="lesson.teachers"
                        placement="top"
                        :disabled="!lesson.isShowTooltip"
                      >
                        <div
                          class="teacher"
                          @mouseenter="
                            visibilityChange(
                              $event,
                              lesson,
                              unitIndex,
                              lessonIndex
                            )
                          "
                        >
                          {{ lesson.teachers }}
                        </div>
                      </el-tooltip>
                    </template>
                    <div v-else class="teacher">
                      {{ lesson.org_nickname }}
                    </div>
                    <div class="lesson-time">
                      <span v-if="[2, 4].includes(lesson.lesson_type)">
                        {{ handleLiveTime(lesson) }}
                      </span>
                      <span v-else>{{ handleDuration(lesson.duration) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { isH5, isHXApp, isMobile } from "@saas/components/src/utils/utils";
import {
  getLessonTypeConfig,
  isLiveLikeLessonType,
} from "@saas/components/src/utils/lesson-type";
import moment from "moment";
export default {
  props: {
    unitList: {
      type: Array,
      default: () => [],
    },
    activeLesson: {
      type: Object,
      default: () => ({}),
    },
    isRegistered: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      isH5: isH5(),
      isElectron: window.isElectron,
      activeNames: [],
    };
  },
  watch: {
    unitList: {
      handler(val) {
        if (this.unitList?.length) {
          this.activeNames = this.unitList.map((item) => item.id);
        } else {
          this.activeNames = [];
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    getLessonStatus(lesson) {
      if (lesson.id === this.activeLesson.id) return "playing";
      if (!this.isRegistered && !lesson.canTrial) return "locked";
      return "not_started";
    },
    getTypeTagClass(lesson) {
      const lessonTypeConfig = getLessonTypeConfig(lesson.lesson_type);
      if (isLiveLikeLessonType(lesson.lesson_type)) {
        return lesson.roomStatus === 2 ? "tag-live-streaming" : "tag-live";
      }
      return lessonTypeConfig.tagClass;
    },
    getTypeTagText(lesson) {
      const lessonTypeConfig = getLessonTypeConfig(lesson.lesson_type);
      if (isLiveLikeLessonType(lesson.lesson_type)) {
        if (lesson.liveStatus === 1) return "视频";
        return lesson.roomStatus === 2 ? "直播中" : "直播";
      }
      return lessonTypeConfig.listLabel;
    },
    visibilityChange(event, lesson, unitIndex, lessonIndex) {
      if (lesson.isShowTooltip !== undefined) return;
      const ev = event.target;
      let ev_size = ev.scrollWidth;
      let content_size = ev.clientWidth;
      if (ev_size > content_size) {
        this.$set(
          this.unitList[unitIndex].lesson_list[lessonIndex],
          "isShowTooltip",
          true
        );
      } else {
        this.$set(
          this.unitList[unitIndex].lesson_list[lessonIndex],
          "isShowTooltip",
          false
        );
      }
    },
    isOverflowing(name) {
      this.$nextTick(() => {
        let ele = document.querySelector(`#${name} span`);
        if (ele) {
          let { scrollWidth, clientWidth } = ele;
          if (scrollWidth > clientWidth) {
            ele.parentElement.classList.add("isOverflowing");
          } else {
            ele.parentElement.classList.remove("isOverflowing");
          }
        } else {
          ele.parentElement.classList.remove("isOverflowing");
        }
      });
    },
    showTeacherInfo(teachers) {
      this.$confirm(teachers, "", {
        showCancelButton: false,
        confirmButtonText: "确定",
        customClass: "saas-confirm-message lesson-teacher-info-confirm",
        confirmButtonClass: "confirm-btn",
        closeOnClickModal: false,
      })
        .then(() => {})
        .catch(() => {});
    },
    handleClickLesson(lesson) {
      if (this.getLessonStatus(lesson) === "locked") return;
      this.$emit("changeLesson", lesson);
    },
    handleDuration(milliseconds) {
      if (!milliseconds) {
        return "";
      }
      const totalSeconds = Math.floor(milliseconds);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      if (!hours) {
        return `${minutes.toString().padStart(2, "0")}:${seconds
          .toString()
          .padStart(2, "0")}`;
      } else {
        return `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
      }
    },
    handleLiveTime(lesson) {
      return `${moment(lesson.live_start_time * 1000).format(
        "MM.DD HH:mm"
      )}-${moment(lesson.live_end_time * 1000).format("HH:mm")}`;
    },
  },
  computed: {},
};
</script>

<style scoped lang="scss">
// 脉冲动画
@keyframes ping {
  75%,
  100% {
    transform: scale(1.8);
    opacity: 0;
  }
}

// 状态图标
.status-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 8px;
  margin-top: 1px;
}
.status-playing {
  position: relative;
  .ping-ring {
    position: absolute;
    inset: 0;
    background: #00c89d;
    border-radius: 50%;
    animation: ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite;
    opacity: 0.2;
  }
  .play-circle {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #00c89d;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 200, 157, 0.3);
    svg {
      margin-left: 1px;
    }
  }
}
.status-locked {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--mg-disabled-bg);
}
.status-not_started {
  border: 2px solid var(--mg-disabled-text);
  background: transparent;
}

// 课程类型标签
.lesson-type-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-weight: 400;
  font-size: 11px;
  line-height: 1;
  padding: 3px 6px;
  width: auto;
  margin-right: 4px;
  white-space: nowrap;

  &.tag-video {
    background: var(--mg-disabled-bg);
    color: var(--mg-disabled-text);
    border: 1px solid var(--mg-border-subtle);
  }
  &.tag-audio {
    background: #faf5ff;
    color: #9333ea;
    border: 1px solid #f3e8ff;
  }
  &.tag-live {
    background: #eff6ff;
    color: #2563eb;
    border: 1px solid #dbeafe;
  }
  &.tag-live-streaming {
    background: #ecfdf5;
    color: #059669;
    border: 1px solid #d1fae5;
    .live-dot-wrap {
      position: relative;
      width: 6px;
      height: 6px;
      margin-right: 4px;
      display: inline-block;
      .live-dot-ping {
        position: absolute;
        inset: 0;
        border-radius: 50%;
        background: #34d399;
        animation: ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite;
        opacity: 0.75;
      }
      .live-dot {
        position: relative;
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #10b981;
      }
    }
  }
  &.tag-unknown {
    background: #f8fafc;
    color: #64748b;
    border: 1px dashed var(--mg-disabled-text);
  }
  &.can-trial {
    color: #00c89d;
    border: 1px solid #00c89d;
    background: rgba(0, 200, 157, 0.05);
  }
}

.tag-row {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.meta-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.lesson-list {
  padding: 12px 8px 12px 12px;
  margin-right: 4px;
  height: 100%;
  overflow: auto;
  html.dark & {
    .collapse-wrap ::v-deep {
      .el-collapse-item__header {
        background: var(--mg-bg-elevated) !important;
        color: var(--mg-text-primary);

        i {
          color: var(--mg-text-primary);
        }
      }

      .el-collapse-item__wrap,
      .el-collapse-item__content {
        background: transparent;
        color: var(--mg-text-secondary);
      }
    }

    .lesson-list-wrap .lesson-item {
      color: var(--mg-text-secondary);

      &::before {
        background: var(--mg-control-hover-bg);
      }

      &:hover {
        background: rgba(17, 28, 49, 0.72);
      }

      .lesson-info,
      .other,
      .teacher,
      .lesson-time,
      .tag-row,
      .meta-row {
        color: var(--mg-text-secondary) !important;
      }

      .lesson-info .name,
      .name {
        color: var(--mg-text-primary) !important;
      }
    }
  }
  &:hover::-webkit-scrollbar-thumb {
    background: #fff;
  }
  .collapse-wrap ::v-deep {
    border: none;
    .el-collapse-item {
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
      .el-collapse-item__arrow {
        display: none;
      }
      .el-collapse-item__header {
        position: sticky;
        top: 0;
        z-index: 10;
        backdrop-filter: blur(8px);
        border: none;
        font-weight: 500;
        font-size: 14px;
        height: 38px;
        color: #0d1400;
        background: rgba(243, 252, 247, 0.95) !important;
        border-radius: 6px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);

        .unit-name {
          word-break: break-all;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          padding-left: 14px;
          .name-text {
            width: 0;
            flex: 1;
            display: inline-block;
          }
          .unit-arrow {
            margin-right: 6px;
            width: 31px;
            height: 18px;
            padding-right: 6px;
            background: var(--mg-control-bg);
            border: 1px solid var(--mg-border-subtle);
            border-radius: 9px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            font-size: 11px;
            .arrow {
              width: 8px;
              height: 6px;
              margin-left: 4px;
              background: url("../../../assets/images/arrow.png");
              background-repeat: no-repeat;
              background-size: 100%;
              transform: rotate(180deg);
              filter: invert(0.6);
              &.collapsed {
                transform: rotate(0deg);
              }
            }
          }
        }
        i {
          color: #0d1400;
          font-size: 12px;
          font-weight: bold;
        }
      }
      .el-collapse-item__wrap {
        background: unset;
        border: none;
        .el-collapse-item__content {
          padding: 0;
        }
      }
    }
  }
  .lesson-list-wrap {
    .lesson-item {
      cursor: pointer;
      box-sizing: border-box;
      width: 100%;
      padding: 10px 12px 10px 4px;
      display: flex;
      align-items: flex-start;
      border-radius: 6px;
      border: none;
      border-left: 4px solid transparent;
      transition: all 0.15s ease;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        left: 14px;
        top: 0;
        bottom: 0;
        width: 2px;
        background: #e2e8f0;
        pointer-events: none;
      }
      &:first-child::before {
        top: 50%;
      }
      &:last-child::before {
        bottom: 50%;
      }
      &:only-child::before {
        display: none;
      }
      &:hover {
        background: rgba(243, 252, 247, 0.5);
      }
      .lesson-info {
        flex: 1;
        overflow: hidden;
        .name {
          width: 100%;
          font-weight: 400;
          font-size: 14px;
          color: #0d1400;
          line-height: 18px;
          word-break: break-all;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .other {
          margin-top: 6px;
          .teacher {
            font-weight: 400;
            font-size: 12px;
            color: #515350;
            line-height: 17px;
            word-break: break-all;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: 5px;
            flex: 1;
          }
          .lesson-time {
            font-weight: 400;
            font-size: 12px;
            color: #515350;
            line-height: 17px;
            max-width: 150px;
          }
        }
      }
    }
    .active-lesson-item {
      border-left: 4px solid #00c89d !important;
      background: rgba(0, 200, 157, 0.06) !important;
      .lesson-info .name {
        color: #00c89d;
        font-weight: 600;
      }
    }
    .lesson-locked {
      opacity: 0.5;
      cursor: not-allowed;
      filter: grayscale(1);
    }
  }
}
.lesson-list::-webkit-scrollbar {
  width: 4px;
}
.lesson-list::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 2px;
}

// H5 适配
.h5-lesson-list {
  padding: 0;
  html.dark & {
    .collapse-wrap ::v-deep {
      .el-collapse-item__header {
        background: var(--mg-bg-elevated) !important;
        color: var(--mg-text-primary);

        i {
          color: var(--mg-text-primary);
        }
      }

      .el-collapse-item__wrap,
      .el-collapse-item__content {
        background: transparent;
        color: var(--mg-text-secondary);
      }
    }

    .lesson-list-wrap .lesson-item {
      color: var(--mg-text-secondary);

      &::before {
        background: var(--mg-control-hover-bg);
      }

      .lesson-info,
      .other,
      .teacher,
      .lesson-time,
      .tag-row,
      .meta-row {
        color: var(--mg-text-secondary) !important;
      }

      .lesson-info .name,
      .name {
        color: var(--mg-text-primary) !important;
      }
    }
  }
  .collapse-wrap ::v-deep {
    border: none;
    .el-collapse-item {
      margin-bottom: 0.3733rem;
      .el-collapse-item__header {
        position: sticky;
        top: 0;
        z-index: 10;
        backdrop-filter: blur(8px);
        font-weight: 500;
        font-size: 0.4267rem;
        color: #0d1400;
        background: rgba(243, 252, 247, 0.95) !important;
        border-radius: 0.16rem;

        .unit-name {
          word-break: break-all;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          flex: 1;
          padding-left: 0.3733rem;
        }
        i {
          color: #0d1400;
          font-size: 0.24rem;
        }
      }
      .el-collapse-item__wrap {
        background: unset;
        .el-collapse-item__content {
          padding: 0;
        }
      }
    }
  }
  .lesson-list-wrap {
    .lesson-item {
      cursor: pointer;
      box-sizing: border-box;
      width: 100%;
      padding: 0.3733rem 0.3733rem 0.3733rem 0.0533rem;
      display: flex;
      align-items: flex-start;
      border-radius: 0.16rem;
      border: none;
      border-left: 4px solid transparent;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        left: 0.3733rem;
        top: 0;
        bottom: 0;
        width: 2px;
        background: #e2e8f0;
        pointer-events: none;
      }
      &:first-child::before {
        top: 50%;
      }
      &:last-child::before {
        bottom: 50%;
      }
      &:only-child::before {
        display: none;
      }
      .lesson-info {
        flex: 1;
        overflow: hidden;
        .name {
          width: 100%;
          font-weight: 400;
          font-size: 0.4267rem;
          color: #0d1400;
          line-height: 0.5867rem;
          word-break: break-all;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .other {
          margin-top: 0.2133rem;
          .teacher {
            width: 0;
            flex: 1;
            font-weight: 400;
            font-size: 0.3733rem;
            color: #515350;
            line-height: 0.5333rem;
            word-break: break-all;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: 0.53rem;
            span {
              flex: 1;
              width: 0;
              word-break: break-all;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .show-all {
              display: none;
              height: 0.31rem;
              padding: 0.1rem 0.1rem 0;
            }
            &.isOverflowing {
              .show-all {
                display: inline-block;
              }
            }
          }
          .lesson-time {
            font-size: 0.3733rem;
            color: #515350;
            line-height: 0.5333rem;
          }
        }
      }
    }
    .active-lesson-item {
      border-left: 4px solid #00c89d !important;
      background: rgba(0, 200, 157, 0.06) !important;
      .lesson-info .name {
        color: #00c89d;
        font-weight: 600;
      }
    }
    .lesson-locked {
      opacity: 0.5;
      cursor: not-allowed;
      filter: grayscale(1);
    }
  }
}
</style>
<style lang="scss">
.moguo-tooltip.video-play-lesson-list.el-tooltip__popper {
  max-width: 300px !important;
}
.lesson-teacher-info-confirm.el-message-box.saas-confirm-message {
  .el-message-box__content {
    font-weight: 500;
    font-size: 14px;
    color: #0d1400;
    line-height: 20px;
  }
  .confirm-btn {
    width: 7.44rem !important;
    border-radius: 20px !important;
  }
}
</style>
